import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  logoAlt: {
    id: 'header.menu.welcome.banner.logo.alt',
    defaultMessage: 'ASU Starbucks Global Academy',
  },
});

export default messages;
